export default "__VITE_ASSET__Bigx1WbT__"